module.exports = __webpack_public_path__ + "ef8eb9931229b2fd029f7d3152918112.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg-en.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg-en.jpg
// module chunks = 40